import React, { createContext, useContext, useState } from "react";

interface Context {
  isMenuVisible: boolean;
  setIsMenuVisible: (isVisible: boolean) => void;
}

const defaultContext = {
  isMenuVisible: true,
  setIsMenuVisible: () => true,
};

const MenuContext = createContext<Context>(defaultContext);

export const MenuProvider = ({ children }: any) => {
  const [isMenuVisible, setIsMenuVisible] = useState<boolean>(true);

  const context = {
    isMenuVisible,
    setIsMenuVisible,
  };

  return (
    <MenuContext.Provider value={context}>{children}</MenuContext.Provider>
  );
};

export const useMenu = () => useContext(MenuContext);
